/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
	Authorigins = "_authOrigins",
	Externalauths = "_externalAuths",
	Mfas = "_mfas",
	Otps = "_otps",
	Superusers = "_superusers",
	Appointments = "appointments",
	Branches = "branches",
	Deleted = "deleted",
	Devices = "devices",
	DoctorBranchRoles = "doctorBranchRoles",
	Doctors = "doctors",
	DoctorsResources = "doctorsResources",
	DoctorsStatistics = "doctorsStatistics",
	DoctorsStorage = "doctorsStorage",
	Documents = "documents",
	Formularies = "formularies",
	FormulariesResponses = "formulariesResponses",
	Invitations = "invitations",
	InvoiceItems = "invoiceItems",
	Invoices = "invoices",
	Notifications = "notifications",
	Patients = "patients",
	Plans = "plans",
	PracticeKpis = "practice_kpis",
	Procedures = "procedures",
	ProceduresTypes = "proceduresTypes",
	Subscriptions = "subscriptions",
	SupportTickets = "supportTickets",
	TrendAnalysis = "trend_analysis",
	VerificationCodes = "verificationCodes",
}

// Alias types for improved usability
export type IsoDateString = string
export type IsoAutoDateString = string & { readonly autodate: unique symbol }
export type RecordIdString = string
export type FileNameString = string & { readonly filename: unique symbol }
export type HTMLString = string

type ExpandType<T> = unknown extends T
	? T extends unknown
		? { expand?: unknown }
		: { expand: T }
	: { expand: T }

// System fields
export type BaseSystemFields<T = unknown> = {
	id: RecordIdString
	collectionId: string
	collectionName: Collections
} & ExpandType<T>

export type AuthSystemFields<T = unknown> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	fingerprint: string
	id: string
	recordRef: string
	updated: IsoAutoDateString
}

export type ExternalauthsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	provider: string
	providerId: string
	recordRef: string
	updated: IsoAutoDateString
}

export type MfasRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	method: string
	recordRef: string
	updated: IsoAutoDateString
}

export type OtpsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	password: string
	recordRef: string
	sentTo?: string
	updated: IsoAutoDateString
}

export type SuperusersRecord = {
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	id: string
	password: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export enum AppointmentsStatusOptions {
	"scheduled" = "scheduled",
	"confirmed" = "confirmed",
	"completed" = "completed",
	"cancelled" = "cancelled",
	"no_show" = "no_show",
	"rescheduled" = "rescheduled",
}

export enum AppointmentsColorOptions {
	"blue" = "blue",
	"green" = "green",
	"red" = "red",
	"yellow" = "yellow",
	"purple" = "purple",
	"orange" = "orange",
}
export type AppointmentsRecord = {
	branch: RecordIdString
	color?: AppointmentsColorOptions
	created: IsoAutoDateString
	doctor: RecordIdString
	duration: number
	id: string
	notified?: boolean
	patient: RecordIdString
	startDate: IsoDateString
	status?: AppointmentsStatusOptions
	title: string
	updated: IsoAutoDateString
}

export type BranchesRecord = {
	address?: string
	created: IsoAutoDateString
	email?: string
	id: string
	image?: FileNameString
	name: string
	phoneNumber?: string
	updated: IsoAutoDateString
}

export type DeletedRecord<Trecord = unknown> = {
	collection: string
	created: IsoAutoDateString
	deletedBy?: string
	id: string
	record: null | Trecord
	recordId: string
	updated: IsoAutoDateString
}

export type DevicesRecord = {
	created: IsoAutoDateString
	doctor: RecordIdString
	id: string
	lastLogin: string
	updated: IsoAutoDateString
	userAgent: string
}

export enum DoctorBranchRolesRoleOptions {
	"owner" = "owner",
	"guest" = "guest",
}
export type DoctorBranchRolesRecord = {
	branch: RecordIdString
	created: IsoAutoDateString
	doctor: RecordIdString
	id: string
	role: DoctorBranchRolesRoleOptions
	updated: IsoAutoDateString
}

export type DoctorsRecord = {
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	firstName?: string
	id: string
	lastName?: string
	password: string
	phoneNumber?: string
	photo?: FileNameString
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export type DoctorsResourcesRecord = {
	branch?: string
	doctor?: string
	id: string
	total?: number
	type?: string
}

export type DoctorsStatisticsRecord = {
	branch?: string
	id: string
	metricType?: string
	month?: number
	total?: number
	type?: string
	year?: number
}

export type DoctorsStorageRecord = {
	branch?: string
	doctor?: string
	id: string
	storageBytes?: number
	type?: string
}

export type DocumentsRecord = {
	created: IsoAutoDateString
	file?: FileNameString
	id: string
	name?: string
	patient: RecordIdString
	size?: number
	updated: IsoAutoDateString
}

export type FormulariesRecord<Tdata = unknown> = {
	branch: RecordIdString
	created: IsoAutoDateString
	data?: null | Tdata
	description?: string
	doctor: RecordIdString
	id: string
	name: string
	updated: IsoAutoDateString
	version: number
}

export type FormulariesResponsesRecord<Tdata = unknown> = {
	created: IsoAutoDateString
	data?: null | Tdata
	formulary: RecordIdString
	id: string
	patient: RecordIdString
	title: string
	updated: IsoAutoDateString
}

export enum InvitationsStatusOptions {
	"pending" = "pending",
	"accepted" = "accepted",
	"rejected" = "rejected",
	"expired" = "expired",
}
export type InvitationsRecord = {
	acceptedAt?: IsoDateString
	branch?: RecordIdString
	created: IsoAutoDateString
	expiresAt?: IsoDateString
	id: string
	invitedBy?: RecordIdString
	invitedDoctor?: RecordIdString
	invitedEmail?: string
	message?: string
	rejectedAt?: IsoDateString
	status?: InvitationsStatusOptions
	token?: string
	updated: IsoAutoDateString
}

export type InvoiceItemsRecord = {
	created: IsoAutoDateString
	id: string
	invoice: RecordIdString
	price?: number
	procedure: string
	updated: IsoAutoDateString
}

export enum InvoicesStatusOptions {
	"generated" = "generated",
	"paid" = "paid",
	"cancelled" = "cancelled",
}
export type InvoicesRecord = {
	branch: RecordIdString
	created: IsoAutoDateString
	doctor: RecordIdString
	id: string
	items?: RecordIdString[]
	patient?: RecordIdString
	status: InvoicesStatusOptions
	total?: number
	updated: IsoAutoDateString
}

export enum NotificationsTypeOptions {
	"appointment" = "appointment",
}
export type NotificationsRecord = {
	created: IsoAutoDateString
	doctor: RecordIdString
	id: string
	readAt?: IsoDateString
	type: NotificationsTypeOptions
	updated: IsoAutoDateString
}

export type PatientsRecord = {
	bornDate?: IsoDateString
	branch: RecordIdString
	created: IsoAutoDateString
	doctor: RecordIdString
	email?: string
	firstName: string
	id: string
	lastName: string
	phoneNumber?: string
	photo?: FileNameString
	updated: IsoAutoDateString
}

export type PlansRecord = {
	created: IsoAutoDateString
	id: string
	maxAppointmentsPerMonth?: number
	maxBranches?: number
	maxDoctors?: number
	maxFormularies?: number
	maxPatients?: number
	maxProcedureTypes?: number
	maxStorageMB?: number
	name?: string
	updated: IsoAutoDateString
	variantID?: string
}

export type PracticeKpisRecord = {
	branch?: string
	cancellationRate?: number
	cancelledAppointments?: number
	doctor?: string
	id: string
	month?: number
	newPatients?: number
	proceduresPerPatient?: number
	revenue?: number
	revenuePerAppointment?: number
	totalAppointments?: number
	totalProcedures?: number
	year?: number
}

export type ProceduresRecord<Todontogram = unknown> = {
	appoiment?: RecordIdString
	branch: RecordIdString
	created: IsoAutoDateString
	doctor: RecordIdString
	documents?: FileNameString[]
	id: string
	odontogram?: null | Todontogram
	patient: RecordIdString
	type: RecordIdString
	updated: IsoAutoDateString
}

export type ProceduresTypesRecord = {
	branch: RecordIdString
	created: IsoAutoDateString
	description: string
	duration: number
	id: string
	name: string
	updated: IsoAutoDateString
}

export enum SubscriptionsStatusOptions {
	"on_trial" = "on_trial",
	"active" = "active",
	"paused" = "paused",
	"past_due" = "past_due",
	"unpaid" = "unpaid",
	"cancelled" = "cancelled",
	"ends_at" = "ends_at",
	"expired" = "expired",
}

export enum SubscriptionsPaymentProcessorOptions {
	"stripe" = "stripe",
	"paypal" = "paypal",
}
export type SubscriptionsRecord = {
	cardBrand?: string
	cardLastFour?: string
	created: IsoAutoDateString
	customerId?: number
	doctor: RecordIdString
	endsAt?: IsoDateString
	id: string
	orderId?: number
	paymentProcessor?: SubscriptionsPaymentProcessorOptions
	plan: RecordIdString
	productId?: number
	renewsAt?: IsoDateString
	status: SubscriptionsStatusOptions
	subscriptionId?: number
	trialEndsAt?: IsoDateString
	updated: IsoAutoDateString
}

export enum SupportTicketsStatusOptions {
	"open" = "open",
	"in_progress" = "in_progress",
	"closed" = "closed",
}
export type SupportTicketsRecord = {
	created: IsoAutoDateString
	email: string
	id: string
	message: string
	status: SupportTicketsStatusOptions
	subject: string
	updated: IsoAutoDateString
}

export type TrendAnalysisRecord = {
	branch?: string
	doctor?: string
	id: string
	month?: number
	monthOverMonthGrowth?: number
	prevMonth?: number
	sameMonthPrevYear?: number
	total?: number
	trendStatus?: string
	type?: string
	year?: number
	yearOverYearGrowth?: number
}

export type VerificationCodesRecord = {
	created: IsoAutoDateString
	doctor: RecordIdString
	expiresAt?: IsoDateString
	id: string
	phoneNumber: string
	updated: IsoAutoDateString
	verificationCode: string
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> = Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> = Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> & BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> & BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> & AuthSystemFields<Texpand>
export type AppointmentsResponse<Texpand = unknown> = Required<AppointmentsRecord> & BaseSystemFields<Texpand>
export type BranchesResponse<Texpand = unknown> = Required<BranchesRecord> & BaseSystemFields<Texpand>
export type DeletedResponse<Trecord = unknown, Texpand = unknown> = Required<DeletedRecord<Trecord>> & BaseSystemFields<Texpand>
export type DevicesResponse<Texpand = unknown> = Required<DevicesRecord> & BaseSystemFields<Texpand>
export type DoctorBranchRolesResponse<Texpand = unknown> = Required<DoctorBranchRolesRecord> & BaseSystemFields<Texpand>
export type DoctorsResponse<Texpand = unknown> = Required<DoctorsRecord> & AuthSystemFields<Texpand>
export type DoctorsResourcesResponse<Texpand = unknown> = Required<DoctorsResourcesRecord> & BaseSystemFields<Texpand>
export type DoctorsStatisticsResponse<Texpand = unknown> = Required<DoctorsStatisticsRecord> & BaseSystemFields<Texpand>
export type DoctorsStorageResponse<Texpand = unknown> = Required<DoctorsStorageRecord> & BaseSystemFields<Texpand>
export type DocumentsResponse<Texpand = unknown> = Required<DocumentsRecord> & BaseSystemFields<Texpand>
export type FormulariesResponse<Tdata = unknown, Texpand = unknown> = Required<FormulariesRecord<Tdata>> & BaseSystemFields<Texpand>
export type FormulariesResponsesResponse<Tdata = unknown, Texpand = unknown> = Required<FormulariesResponsesRecord<Tdata>> & BaseSystemFields<Texpand>
export type InvitationsResponse<Texpand = unknown> = Required<InvitationsRecord> & BaseSystemFields<Texpand>
export type InvoiceItemsResponse<Texpand = unknown> = Required<InvoiceItemsRecord> & BaseSystemFields<Texpand>
export type InvoicesResponse<Texpand = unknown> = Required<InvoicesRecord> & BaseSystemFields<Texpand>
export type NotificationsResponse<Texpand = unknown> = Required<NotificationsRecord> & BaseSystemFields<Texpand>
export type PatientsResponse<Texpand = unknown> = Required<PatientsRecord> & BaseSystemFields<Texpand>
export type PlansResponse<Texpand = unknown> = Required<PlansRecord> & BaseSystemFields<Texpand>
export type PracticeKpisResponse<Texpand = unknown> = Required<PracticeKpisRecord> & BaseSystemFields<Texpand>
export type ProceduresResponse<Todontogram = unknown, Texpand = unknown> = Required<ProceduresRecord<Todontogram>> & BaseSystemFields<Texpand>
export type ProceduresTypesResponse<Texpand = unknown> = Required<ProceduresTypesRecord> & BaseSystemFields<Texpand>
export type SubscriptionsResponse<Texpand = unknown> = Required<SubscriptionsRecord> & BaseSystemFields<Texpand>
export type SupportTicketsResponse<Texpand = unknown> = Required<SupportTicketsRecord> & BaseSystemFields<Texpand>
export type TrendAnalysisResponse<Texpand = unknown> = Required<TrendAnalysisRecord> & BaseSystemFields<Texpand>
export type VerificationCodesResponse<Texpand = unknown> = Required<VerificationCodesRecord> & BaseSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	_authOrigins: AuthoriginsRecord
	_externalAuths: ExternalauthsRecord
	_mfas: MfasRecord
	_otps: OtpsRecord
	_superusers: SuperusersRecord
	appointments: AppointmentsRecord
	branches: BranchesRecord
	deleted: DeletedRecord
	devices: DevicesRecord
	doctorBranchRoles: DoctorBranchRolesRecord
	doctors: DoctorsRecord
	doctorsResources: DoctorsResourcesRecord
	doctorsStatistics: DoctorsStatisticsRecord
	doctorsStorage: DoctorsStorageRecord
	documents: DocumentsRecord
	formularies: FormulariesRecord
	formulariesResponses: FormulariesResponsesRecord
	invitations: InvitationsRecord
	invoiceItems: InvoiceItemsRecord
	invoices: InvoicesRecord
	notifications: NotificationsRecord
	patients: PatientsRecord
	plans: PlansRecord
	practice_kpis: PracticeKpisRecord
	procedures: ProceduresRecord
	proceduresTypes: ProceduresTypesRecord
	subscriptions: SubscriptionsRecord
	supportTickets: SupportTicketsRecord
	trend_analysis: TrendAnalysisRecord
	verificationCodes: VerificationCodesRecord
}

export type CollectionResponses = {
	_authOrigins: AuthoriginsResponse
	_externalAuths: ExternalauthsResponse
	_mfas: MfasResponse
	_otps: OtpsResponse
	_superusers: SuperusersResponse
	appointments: AppointmentsResponse
	branches: BranchesResponse
	deleted: DeletedResponse
	devices: DevicesResponse
	doctorBranchRoles: DoctorBranchRolesResponse
	doctors: DoctorsResponse
	doctorsResources: DoctorsResourcesResponse
	doctorsStatistics: DoctorsStatisticsResponse
	doctorsStorage: DoctorsStorageResponse
	documents: DocumentsResponse
	formularies: FormulariesResponse
	formulariesResponses: FormulariesResponsesResponse
	invitations: InvitationsResponse
	invoiceItems: InvoiceItemsResponse
	invoices: InvoicesResponse
	notifications: NotificationsResponse
	patients: PatientsResponse
	plans: PlansResponse
	practice_kpis: PracticeKpisResponse
	procedures: ProceduresResponse
	proceduresTypes: ProceduresTypesResponse
	subscriptions: SubscriptionsResponse
	supportTickets: SupportTicketsResponse
	trend_analysis: TrendAnalysisResponse
	verificationCodes: VerificationCodesResponse
}

// Utility types for create/update operations

type ProcessCreateAndUpdateFields<T> = Omit<{
	// Omit AutoDate fields
	[K in keyof T as Extract<T[K], IsoAutoDateString> extends never ? K : never]: 
		// Convert FileNameString to File
		T[K] extends infer U ? 
			U extends (FileNameString | FileNameString[]) ? 
				U extends any[] ? File[] : File 
			: U
		: never
}, 'id'>

// Create type for Auth collections
export type CreateAuth<T> = {
	id?: RecordIdString
	email: string
	emailVisibility?: boolean
	password: string
	passwordConfirm: string
	verified?: boolean
} & ProcessCreateAndUpdateFields<T>

// Create type for Base collections
export type CreateBase<T> = {
	id?: RecordIdString
} & ProcessCreateAndUpdateFields<T>

// Update type for Auth collections
export type UpdateAuth<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof AuthSystemFields>
> & {
	email?: string
	emailVisibility?: boolean
	oldPassword?: string
	password?: string
	passwordConfirm?: string
	verified?: boolean
}

// Update type for Base collections
export type UpdateBase<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof BaseSystemFields>
>

// Get the correct create type for any collection
export type Create<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? CreateAuth<CollectionRecords[T]>
		: CreateBase<CollectionRecords[T]>

// Get the correct update type for any collection
export type Update<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? UpdateAuth<CollectionRecords[T]>
		: UpdateBase<CollectionRecords[T]>

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = {
	collection<T extends keyof CollectionResponses>(
		idOrName: T
	): RecordService<CollectionResponses[T]>
} & PocketBase
